import { render } from "./disabling-hris-warning.vue?vue&type=template&id=3f71c52c&lang=pug"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__